import { forwardRef } from 'react';
import TEditor from "./TEditor";

const ForwardedTEditor = forwardRef(TEditor);

ForwardedTEditor.displayName = 'ForwardedTEditor';

export default ForwardedTEditor;